import { render, staticRenderFns } from "./AddressAutocomplete.vue?vue&type=template&id=716a89fc&scoped=true&"
import script from "./AddressAutocomplete.vue?vue&type=script&lang=js&"
export * from "./AddressAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./AddressAutocomplete.vue?vue&type=style&index=0&id=716a89fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716a89fc",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VList,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('716a89fc')) {
      api.createRecord('716a89fc', component.options)
    } else {
      api.reload('716a89fc', component.options)
    }
    module.hot.accept("./AddressAutocomplete.vue?vue&type=template&id=716a89fc&scoped=true&", function () {
      api.rerender('716a89fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AddressAutocomplete.vue"
export default component.exports